import { useState, useEffect } from 'react';

import { FinanceService } from '../../../core/services/FinanceService';
import { Singleton } from '../../../core/services/Singleton';
interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    _disable?: boolean;
    returnList?:any;
}
export const SelectBudgetResource = ({ idSelector, onChange, label, _disable,returnList }: Props) => {

    const service = new FinanceService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])


    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {

        service.getBudgetResourceCatalog(null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                    if(returnList)
                    {
                        returnList(resp.DataBeanProperties.ObjectValue);
                    }
                }
            }
        );
    }

    return (
        <>
            <label>{label ?? "Recurso Presupuestal"}</label>
            <select disabled={_disable} className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (

                            <option key={item.DataBeanProperties.IDBudgetResource} value={item.DataBeanProperties.IDBudgetResource} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}